import { render } from "./BasisForInvoiceSection.vue?vue&type=template&id=02a23c03&scoped=true"
import script from "./BasisForInvoiceSection.vue?vue&type=script&lang=js"
export * from "./BasisForInvoiceSection.vue?vue&type=script&lang=js"

import "./BasisForInvoiceSection.vue?vue&type=style&index=0&id=02a23c03&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02a23c03"]])

export default __exports__